/**
 * Created by marks on 10.01.2017.
 */
import HttpQuery from './HttpQuery';

class LoginApi {

    static getLoginPassword(login, password, rememberMe) {
        const res = { grant_type: "password", username: login, password: password };
        if (typeof rememberMe !== "undefined") {
            res.rememberMe = rememberMe;
        }
        return res;
    }

    static processLogin(login, password, rememberMe) {
        const data = LoginApi.getLoginPassword(login, password, rememberMe);

        let hq = new HttpQuery();

        return new Promise((resolve, reject) => {
            hq.makeLoginPost(data)
                .then(d => resolve(d))
                .catch(d => reject(d));
        });
    }

    static processLogout() {
        let hq = new HttpQuery();
        return hq.makeApiCallPost("Account/Logout", {});
    }
}

export default LoginApi;
